import React, { useCallback } from 'react'
import { FlatList } from 'react-native'

import { zodResolver } from '@hookform/resolvers/zod'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { Stack } from '@zet/design-system'
import { KeyBoardWrapper } from '@zet/utils'
import { useAddCustomerState } from '@zet/zet-pro-quick-journey/hooks/useAddCustomer'
import { useForm } from 'react-hook-form'

import { Button, ScreenTitle } from '../../components'
import FormController from '../../form/FormController'
import { sendAnalyticsData } from '../../utils/analyticsEvents'
import { customerBasicDetailsValidationSchema } from '../../utils/validationSchemas'
import { customerBasicDetailsFormFields } from './formFields'

export const CustomerBasicDetails = () => {
  const { mutate, isLoading } = useAddCustomerState()
  const { customerId } = useAddCustomerStore()

  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm({
    mode: 'onTouched',
    resolver: zodResolver(customerBasicDetailsValidationSchema),
  })

  const renderItem = useCallback(({ item }) => {
    return <FormController control={control} ocField={item} />
  }, [])

  const handleSubmit = () => {
    sendAnalyticsData({
      screen: 'SHOW_BASIC_DETAILS_SCREEN_JFS',
      type: 'click',
    })
    const { employmentType, pincode, annualIncome, modeOfIncome } = getValues()
    const urlParams = new URLSearchParams(window.location.search)

    const custId = urlParams.get('customerId')
    const monthlyIncome = annualIncome.replace(/,/g, '')

    const requestBodyData = {
      employmentType,
      pinCode: pincode,
      annualIncome: monthlyIncome,
      modeOfIncome,
      customerId: custId || customerId,
      screenName: 'SHOWN_BASIC_DETAILS_SCREEN_JFS',
    }
    mutate(requestBodyData, {
      onSuccess: (data) => {
        sendAnalyticsData({ screen: data?.action, type: 'screen' })
      },
    })
  }

  return (
    <KeyBoardWrapper
      BottomSheet={
        <Button
          disabled={!isValid || isLoading}
          onPress={handleSubmit}
          color="bg-primary-100"
          title={'Continue'}
          loading={isLoading}
          loaderText="Verifying"
        />
      }
    >
      <Stack className="bg-white px-3">
        <FlatList
          showsVerticalScrollIndicator={false}
          data={customerBasicDetailsFormFields}
          ListHeaderComponent={
            <ScreenTitle title={'Enter Your Basic Details'} />
          }
          renderItem={renderItem}
        />
      </Stack>
    </KeyBoardWrapper>
  )
}
